import axios from "axios";
import { SERVER_URL } from "../constants";

export const possibleErrorMessageKeys = ["detail", "errorMessage", "message"];

export const getTaskProgressV1 = async (
  taskId: string,
  tokenOverride?: string
): Promise<any> => {
  try {
    const response = await axios.get(
      `${SERVER_URL}/cloudwebportal/api/v1/tasks/?task_id=${taskId}`,
      tokenOverride
        ? { headers: {
            Authorization: `MSBEARER ${tokenOverride}`,
          }}
        : undefined
    );
    return response;
  } catch (error) {
    let errorMessage = "Task Failed";
    if (error.response?.data) {
      for (let key of possibleErrorMessageKeys) {
        if (key in error.response.data) {
          errorMessage = error.response.data[key];
          break;
        }
      }
    }

    throw new Error(`Error fetching task progress: ${errorMessage}`);
  }
};
